import { render } from "./CollecionRequestModal.vue?vue&type=template&id=430cc37a"
import script from "./CollecionRequestModal.vue?vue&type=script&lang=js"
export * from "./CollecionRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__